import { QuestionBase } from './question-base.model';

export class dynamicTableQuestion extends QuestionBase<any> {
    controlType = 'dynamic-table';
    tabular_list: any;
    constructor(options: {} = {}) {
        super(options);
        this.tabular_list = options['tabular_list'] != undefined ? options['tabular_list'] : false;
    }
}
